import React from 'react';
import XlsxImportModal from '../../components/XlsxImportModal';
import { importMaterials, MATERIAL_IMPORT_TEMPLATE_PATH } from '../../api/material';

interface Props {
    open: boolean;
    onClose: () => void;
    /** 导入直接入库成功后回调 (走审批流时数据未变, 不触发) */
    onImported?: () => void;
}

// 材料批量导入 (xlsx): 交互全在通用 XlsxImportModal 里, 这里只绑模板与上传接口.
const MaterialImportModal = ({ open, onClose, onImported }: Props) => (
    <XlsxImportModal
        open={open}
        onClose={onClose}
        onImported={onImported}
        title="批量导入材料 (xlsx)"
        templatePath={MATERIAL_IMPORT_TEMPLATE_PATH}
        templateName="material-import-template.xlsx"
        upload={importMaterials}
    />
);

export default MaterialImportModal;
